import reduxThunk from 'redux-thunk';

const staticMiddleware = [reduxThunk];

export default () => [...staticMiddleware];
